import React, { Component } from 'react'
import { connect } from 'react-redux'

class Color extends Component {
    
    render() {
        let colorValues = [];
        let prodcolor
        if (this.props.colorValue && this.props.colorValue.colorList) {
            this.props.colorValue.colorList.map((colorValueitems, index) => {
                if(colorValueitems.name){
                    prodcolor=colorValueitems.name.replace(/\s/g, '')
                    }
                    else{
                     prodcolor=colorValueitems.name
                    }
                colorValues.push(
                <ul>
                    <li> 
                        <input className="value" id={colorValueitems.name} type="checkbox" 
                        name={colorValueitems.name} checked={this.props.preSelection("color",colorValueitems.name)}
                        onClick={()=>this.props.action("color",colorValueitems.name)}/>
                        <label for={colorValueitems.name} role="checkbox" aria-checked="false" >
                        <button className={"product-color bg-"+ prodcolor.toLowerCase()} id="prod670040_sku830084_sku830084" title={colorValueitems.name}></button>
                        <span className="bg-black" style={{backgroundColor:colorValueitems.name}} 
                        ></span> {colorValueitems.name} ({colorValueitems.count})</label>
                    </li>
                </ul>
                )})
        }
        return (
            <React.Fragment>
                <div  >
                    <li className="m_accordion-details m_single" style={{ display: this.props.showColor ? 'none' : 'block' }}>
                        <ul className="no-bullet margin-bottom-zero">
                            {colorValues}
                        </ul>
                    </li>
                </div>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {

        cartProduct: state.cartProductDataSMB,
        filterDataValue: state.productsSMB.filterData
    }
}
export default (connect(
    mapStateToProps
)(Color));


